import { createFileRoute } from '@tanstack/react-router';
import { ChecklistPage } from './checklist';

export const Route = createFileRoute('/_dashboard/dashboard/settings/checklist/new')({
  component: ChecklistPage,
});
